<template>
  <div id="contenedor-vista-previa-pdf">
    <object
      :data="rutaArchivo"
      type="application/pdf"
      :height="height"
      :width="width">
    </object>
  </div>
</template>

<script>
export default {
  name: 'VistaPreviaPdf',
  props: {
    rutaArchivo: {
      type: String,
      required: true,
    },
    height: {
      type: String,
      required: false,
      default: '400',
    },
    width: {
      type: String,
      required: false,
      default: '100%',
    },
  },
  data() {
    return {};
  },
};
</script>

<style>
</style>
